export default class StatsPanel {
  public dom: HTMLCanvasElement;

  public update: (value: number, maxValue: number) => void;

  constructor(name: string, fg: string, bg: string) {
    let min: number = Infinity; let max: number = 0; const
      { round } = Math;
    const PR: number = round(window.devicePixelRatio || 1);
    const WIDTH: number = 80 * PR; const HEIGHT = 48 * PR;
    const TEXT_X: number = 3 * PR; const TEXT_Y = 2 * PR;
    const GRAPH_X: number = 3 * PR; const GRAPH_Y = 15 * PR;
    const GRAPH_WIDTH: number = 74 * PR; const
      GRAPH_HEIGHT = 30 * PR;

    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = WIDTH;
    canvas.height = HEIGHT;
    canvas.style.cssText = 'width:80px;height:48px';

    const context: CanvasRenderingContext2D = canvas.getContext('2d');
    context.font = `bold ${9 * PR}px Helvetica,Arial,sans-serif`;
    context.textBaseline = 'top';

    context.fillStyle = bg;
    context.fillRect(0, 0, WIDTH, HEIGHT);
    context.fillStyle = fg;
    context.fillText(name, TEXT_X, TEXT_Y);
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

    context.fillStyle = bg;
    context.globalAlpha = 0.9;
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

    /**
     * public
    */
    this.dom = canvas;
    this.update = (value: number, maxValue: number): void => {
      min = Math.min(min, value);
      max = Math.max(max, value);

      context.fillStyle = bg;
      context.globalAlpha = 1;
      context.fillRect(0, 0, WIDTH, GRAPH_Y);
      context.fillStyle = fg;
      context.fillText(`${round(value)} ${name} (${round(min)}-${round(max)})`, TEXT_X, TEXT_Y);
      context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);
      context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);
      context.fillStyle = bg;
      context.globalAlpha = 0.9;
      context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - (value / maxValue)) * GRAPH_HEIGHT));
    };
  }
}
